import { render, staticRenderFns } from "./cancer.vue?vue&type=template&id=49fdbc78&scoped=true"
import script from "./cancer.vue?vue&type=script&lang=js"
export * from "./cancer.vue?vue&type=script&lang=js"
import style0 from "./cancer.vue?vue&type=style&index=0&id=49fdbc78&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fdbc78",
  null
  
)

export default component.exports